<template>
  <transition name="fade">
    <div key="1" v-if="!$store.state.show.app" style="height: 100vh; width: 100vw"
      class="flex column label loading center">
      <img v-if="$store.state.app.basics.logo" style="height: 10vh; width: 10vh" :src="$store.state.app.basics.logo"
        alt="" />
      <span style="max-width: 80vw; overflow-wrap: anywhere" class="flex column center center-text">
        <code v-if="siteLoading.length > 144">
          {{ $store.state.app.basics["app name"] || domainCheck || "XMBL" }}
          may be offline. Please refresh or wait until the connection is
          re-established.
          <button
            class="xs-font t32 fill update-border update-text"
            @click="reload()"
          >
            Reload
          </button>
        </code>
        <div
          style="color: #fefffe; background: #000100; height: 100vh; width: 100vw; position: absolute; top: 0; left: 0;"
          v-else class="flex md-font">
          {{
            "Xmbling " +
            ($store.state.app.basics["app name"] || domainCheck || "XMBL")
          }}
          <span class="xs-font"> {{ siteLoading }}</span>
        </div>
      </span>
    </div>
    <div class="fill-h container p32" v-else-if="$store.state.devmode">
      <h1>Dev Mode</h1>
      <function></function>
      <state></state>
    </div>
    <div key="5" style="height: 100vh" v-else-if="maintenance.maintain && maintenance.maintain.brb"
      class="flexw xl-font center flex column">
      <!-- This is the beginning of decentralized data privacy -->
      <div style="
          height: 66%;
          width: 50%;
          min-width: 270px;
          max-width: 540px;
          text-align: center;
        " class="p16 flex center column glow">
        <b class="p8">{{ $store.state.app.basics["app name"] || domainCheck }} is on work
          holiday.</b>
        <code class="md-font p8">{{ maintenance.maintain.message }}</code>
        <button v-if="maintenance.reload" type="button" @click="reload()">
          Try Again
        </button>
        <img style="width: 80%; object-fit: contain" class="p16" src="/img/stock/logo.svg" alt="maintenance" />
      </div>
    </div>

    <div key="2 + $store.state.componentKeys.auth" v-on:keyup.esc="$store.commit('closeAll', { only: [], except: [] })"
      id="app" style="
        height: 100vh;
        width: 100%;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        overflow-behavior: none;
      " v-else-if="
        $store.state.app &&
        $store.state.app.basics &&
        $store.state.app.basics.database === domainCheck &&
        (($store.state.app.basics && $store.state.app.basics.live) ||
          ($store.state.app.user &&
            $store.state.app.user.indexOf($store.state.auth.uid) > -1) ||
          ($store.state.app.advanced.roles.admin &&
            $store.state.app.advanced.roles.admin.members &&
            $store.state.app.advanced.roles.admin.members.includes(
              $store.state.auth.uid
            )) ||
          ($store.state.app.basics.preview &&
            $store.state.app.pages &&
            $store.state.app.pages[$store.state.app.basics.preview]))
      ">
      <layout :id="`layout_${$store.state.app.basics.database}`">
        <template #header>
          <inav :key="'home_menu' + $store.state.counter" id="home_menu"
            :class="`home_menu_${$store.state.app.basics.database}`" :nohide="$store.state.app.basics.menus &&
              $store.state.app.basics.menus['home'] &&
              $store.state.app.basics.menus['home'].nohide
              " v-if="$store.state.app.basics.menus" style="width: 100%; position: relative; z-index: 1;" name="home" />
        </template>
        <template #content>
          <main ref="main" id="main">
            <transition name="fade">
              <div>
                <ipage 
                  v-if="showPreviewPage"
                  :pagetitle="previewPageTitle"
                  :key="'preview_' + previewPageTitle"
                />
                <router-view 
                  v-else
                  :class="'fill main_' +
                    ($route.params.iitemid ||
                      $route.params.pagetitle ||
                      $route.params.pagetitle ||
                      $route.name)
                    " 
                  :key="$route.fullPath"
                ></router-view>
              </div>
            </transition>
            <ipage v-if="
              $store.state.app.pages.footer &&
              $store.state.app.pages.footer.published
            " pagetitle="footer" />
          </main>
        </template>
        <template #footer>
          <div class="flex align-center justify-start z10 p8" style="position: fixed; bottom: 0;  z-index:11">
            <foot style="position: fixed;" class="flex align-center sm-font"></foot>
          </div>
        </template>
      </layout>
      <div v-if="$store.state.show.secretBox" class="active-input sm-font" style="
          position: fixed;
          bottom: 38px;
          right: 4px;
          max-height: 81vh;
          overflow-y: scroll;
          min-width: 180px;
          border: 1px rgba(255, 255, 255, 0.4) solid;
          z-index: 99999;
        ">
        <div class="secret-info center" v-if="$store.state.secretCode.length > 19">
          <code>Your secret code.. touch it to copy and then send to others.</code>
          <h1 @click="
            $copyText($store.state.secretCode);
          verify = true;
          ">
            {{ $store.state.secretCode }}
          </h1>
          <h2 v-if="verify">Code copied to clipboard!</h2>
        </div>
        <div v-if="$store.state.secretEvent" class="secret-info flex center stretch between wrap">
          <img :src="$store.state.secretEvent.image" style="
              max-width: 50%;
              min-width: 120px;
              max-height: auto;
              object-fit: cover;
              flex: 1 1 50%;
            " />
          <div style="flex: 2 1 50%">
            <h2>{{ $store.state.secretEvent.title }}</h2>
            <p>WHEN: {{ $store.state.secretEvent.datetime }}</p>
            <p>WHERE: {{ $store.state.secretEvent.location }}</p>
            <p>WHY: {{ $store.state.secretEvent.desc }}</p>
            <p v-linkified>HOW: {{ $store.state.secretEvent.tickets }}</p>
            <button type="button" @click="
              $store.state.secretEvent = false;
            secretCode = '';
            ">
              <i class="fa fa-times"></i> Close
            </button>
          </div>
        </div>
        <label v-if="secretCode.length === 20" @click="
          checkSecret(secretCode);
        $store.state.secretEvent;
        " class="input-icon-search fa fa-search fa-xs"></label>
        <input v-model="secretCode" id="secret-code" class="input-with-icon sm-font" type="text"
          placeholder="Secret code?" />
      </div>
      <transition name="drop">
        <div v-if="$store.state.show.jobs || $store.state.show.events" class="module-popdown container">
          <code v-if="
            $store.state.show.cart &&
            !(
              $store.state.user[$store.state.auth.uid].cart ||
              $store.state.anon.cart
            )
          " class="container">Nothing in cart</code>
          <jobs :key="$store.state.componentKeys.jobs" class="sub-container flexw" v-if="
            ($store.state.related.jobs || $store.state.anon.jobs) &&
            $store.state.show.jobs
          "></jobs>
          <code v-else-if="
            $store.state.show.jobs &&
            !($store.state.related.jobs || $store.state.anon.jobs)
          " class="container">Nothing in jobs</code>
          <events :key="$store.state.componentKeys.events" class="sub-container flexw" v-if="
            ($store.state.related.events || $store.state.anon.events) &&
            $store.state.show.events
          "></events>
          <code v-else-if="
            $store.state.show.events &&
            !($store.state.related.events || $store.state.anon.events)
          " class="container">Nothing in events</code>
        </div>
      </transition>

      <transition name="drop">
        <div v-if="$store.state.show.messages" class="com-popdown">
          <message :key="6" class="container" style="overflow: scroll"></message>
        </div>
      </transition>

      <transition name="drop">
        <div v-if="$store.state.show.notifications" class="com-popdown">
          <notifications :key="7" class="sub-container" style="overflow: scroll"></notifications>
        </div>
      </transition>

      <div class="auth-modal" v-if="$store.state.show.auth">
        <div>
          <div class="flex column container" style="min-width: 260px">
            <div class="flex between p8 align-center">
              <code class="xs-font">
          <b>Authentication</b>
        </code>
              <i @click="$set($store.state.show, 'auth', false)" class="fa fa-times fa-lg"></i>
            </div>
            <login></login>
          </div>
        </div>
      </div>
      <pointer :id="Object.keys($store.state.pointer).length" :key="Object.keys($store.state.pointer).length"></pointer>
    </div>

    <div key="3" class="flex column wrap center" v-else-if="
      $store.state.app &&
      $store.state.app.basics &&
      $store.state.app.basics.database === 'fresh'
    " style="height: 100vh; overflow-y: scroll">
      <div style="position: relative" class="container">
        <div class="flex align-center gui-container" style="
            background: rgba(255, 255, 255, 0.9);
            color: black;
            position: fixed;
            top: 4px;
            right: 4px;
            z-index: 99999;
          ">
          <b>{{ domainCheck }}</b>
          <span class="sm-font l4 success-text">[ Unclaimed ]</span>
          <i v-if="$store.state.auth.uid" class="fas fa-unlock p4"
            @click="$store.dispatch('auth', { type: 'logout' })"></i>
        </div>
      </div>
      <div class="flex around wrap" style="overflow: scroll; -webkit-overflow-scrolling: touch; width: 100%; padding: 16px; box-sizing: border-box;">
        <div class="align-center flex m32 container" style="width: 100%; max-width: 540px; margin: 0 auto;">
          <div class="flex column" style="width: 100%; min-width: 0; max-width: 100%; padding: 24px 16px;" v-if="!$store.state.auth.uid">
            <div class="" style="width: 100%;">

              <div class="flex b16 align-center">
                <img src="/img/stock/logo-animated.svg" alt class="r16" style="width: 60px; height: 60px; max-width: 60px; max-height: 60px; flex-shrink: 0; object-fit: contain;" />
                <div class="column flex" style="flex: 1; min-width: 0;">
                  <h1 class="xl-font boldest" style="word-wrap: break-word; overflow-wrap: break-word;">XMBL Software Platform <span class="indicate-text xs-font ">
                      [ ALPHA ]
                    </span></h1>
                  <i class="update-text sm-font" style="word-wrap: break-word; overflow-wrap: break-word;">Full-stack as a service. Powerful, flexible, nearly free</i>
                </div>
              </div>

              <div class="b16">Would you like to build a marketplace, social network, content aggregator, or something else?</div>
              <div class="t16 b16">XMBL applications provide custom functions, 40+ system components, blockchain interaction for NFT/cryptos, and more.</div>
              <hr>
              <div class=" align-center wrap" style="gap: 12px;">
                <div class="lg-font center" style="flex-shrink: 0;">
                  Sign in to claim your instance on
                  <b>{{ domainCheck }}</b>
                  <login class="t16 b16"></login>
                  
                </div>
              </div>
              <hr>
              <div class="flex column" style="margin-top: 16px; gap: 8px;">
                <span style="word-wrap: break-word; overflow-wrap: break-word;"><b>DISCLAIMER:</b> Use at own risk! XMBL assumes no liability and provides no guarantees.

                <a href="https://discord.gg/tUmfa6PAcF" target="_blank" style="word-wrap: break-word; overflow-wrap: break-word;"><i class="fab fa-discord"></i> Discord for chats and info.</a>
                <span></span></span>
              </div>
            </div>

          </div>
          <div v-else style="width: 100%;">
            <div class="container fill" style="height: 75vh; max-width: 100%; width: 100%; overflow: scroll; padding: 16px; box-sizing: border-box;">
              <keep-alive>
                <component id="iform_app" :is="'iform'" relative="true" :form-model="$store.state.models.iform['app']"
                  class="sub-container fill iform_app"></component>
              </keep-alive>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div key="4" class="container flex center column flexw" style="width: 100%"
      v-else-if="$store.state.app.basics['app name']">
      <h1>{{ $store.state.app.basics["app name"] }}</h1>
      <login></login>
      <i @click="$store.dispatch('auth', { type: 'logout' })" v-if="$store.state.auth.uid" class="fas fa-unlock"></i>
    </div>

    <div class="center" style="height: 100vh" v-else>brb</div>
  </transition>
</template>

<script>
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import Vue2Filters from "vue2-filters";
import ipage from "./components/uxui/ipage.vue";

Vue.use(VueClipboard);
export default {
  components: { ipage },
  created() {
    console.log("Creating");
    if (location.href.indexOf("token=") > -1) {
      let token = location.href.split("token=")[1];
      this.$store.dispatch("auth", { type: "token", token }).then(() => {
        console.log("Auth in", this.$store.state.auth.uid);
        return this.$store.dispatch("query", {
          type: "user",
          id: this.$store.state.auth.uid,
        });
      });
    }
    
    // Check if returning from Stripe Checkout (success or cancelled)
    const urlParams = new URLSearchParams(window.location.search);
    const paymentStatus = urlParams.get('payment');
    if (paymentStatus && window.location.pathname.includes('/orders/')) {
      const orderId = window.location.pathname.split('/orders/')[1]?.split('?')[0];
      if (orderId) {
        console.log('[PAYMENT] Returning from Stripe Checkout, status:', paymentStatus);
        if (paymentStatus === 'success') {
          // Webhook should have already updated the order, but check status
          console.log('[PAYMENT] Payment successful via Stripe Checkout');
          // Clean up URL
          window.history.replaceState({}, document.title, `/orders/${orderId}`);
        } else if (paymentStatus === 'cancelled') {
          console.log('[PAYMENT] Payment cancelled by user');
          // Clean up URL
          window.history.replaceState({}, document.title, `/orders/${orderId}`);
        }
      }
    }
    
    // Check if returning from Stripe 3D Secure redirect
    const pendingPaymentIntent = window.localStorage.getItem('pendingPaymentIntent');
    const pendingOrderId = window.localStorage.getItem('pendingOrderId');
    if (pendingPaymentIntent && pendingOrderId && window.location.pathname.includes('/orders/')) {
      console.log('[PAYMENT] Checking payment status after Stripe redirect...');
      // Check PaymentIntent status via backend
      const cloudurl = this.$store.state.cloudurl || 'https://us-central1-xmba-cloud-api.cloudfunctions.net/';
      const axios = require('axios');
      axios.post(cloudurl + 'charge', {
        paymentIntentId: pendingPaymentIntent,
        checkStatus: true
      }).then((response) => {
        console.log('[PAYMENT] Payment status after redirect:', response.data);
        if (response.data.status === 'succeeded') {
          this.$store.dispatch('update', {
            type: 'orders',
            id: pendingOrderId,
            data: { paid: 'credit card' }
          });
        } else if (response.data.status === 'failed') {
          this.$store.dispatch('notify', {
            type: 'billing',
            text: 'Transaction failed: ' + (response.data.error || 'Payment failed'),
            users: [this.$store.state.auth.uid],
            from: 'Stripe',
            link: `/orders/${pendingOrderId}`,
            id: pendingOrderId
          });
        }
        window.localStorage.removeItem('pendingPaymentIntent');
        window.localStorage.removeItem('pendingOrderId');
      }).catch((error) => {
        console.error('[PAYMENT] Error checking payment status:', error);
        window.localStorage.removeItem('pendingPaymentIntent');
        window.localStorage.removeItem('pendingOrderId');
      });
    }
    
    this.$store.commit("setStyle");
    window.onresize = () => {
      this.$store.state.windowWidth = window.innerWidth;
      this.$store.state.windowHeight = window.innerHeight;
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.app.advanced &&
        this.$store.state.app.advanced.roles &&
        this.$store.state.app.advanced.roles.admin &&
        this.$store.state.app.advanced.roles.admin.members &&
        this.$store.state.app.advanced.roles.admin.members.includes(
          this.$store.state.auth.uid
        );
    },
    isSiteLive() {
      return this.$store.state.app.basics && this.$store.state.app.basics.live;
    },
    previewPageTitle() {
      return this.$store.state.app.basics && this.$store.state.app.basics.preview
        ? this.$store.state.app.basics.preview
        : null;
    },
    showPreviewPage() {
      // Only show preview page for non-admin users when site is not live
      return !this.isSiteLive &&
        !this.isAdmin &&
        this.previewPageTitle &&
        this.$store.state.app.pages &&
        this.$store.state.app.pages[this.previewPageTitle];
    },
  },
  data() {
    return {
      domainCheck: encodeURIComponent(window.location.hostname),
      maintenance: {},
      scrollVal: 0,
      secretCode: "",
      rollYourOwn: "",
      show: {
        auth: false,
        roll: false,
        maintenance: {},
      },
      siteLoading: ".",
      verify: false,
      wizard: false,
    };
  },
  methods: {
    reload() {
      window.location.reload();
    },
  },
  mixins: [Vue2Filters.mixin],
  mounted: async function () {
    for (var loading = 0; loading < 145; loading++) {
      setTimeout(() => {
        this.siteLoading = this.siteLoading.length < 5 ? this.siteLoading + "." : '.';
      }, (loading + 1) * 150);
    }

    if (window.localStorage.getItem("auth") === "null") {
      window.localStorage.removeItem("auth");
      this.$store.state.auth = {};
    }

    if (
      window.location.href.includes("&mode=signIn&lang=en") &&
      !this.$store.state.auth.uid
    ) {
      console.log("complete signup");
      this.$store.dispatch("auth", { type: "signinwithemaillink" });
    } else if (
      window.localStorage.key("auth") &&
      window.localStorage.getItem("auth") !== null
    ) {
      var auth = JSON.parse(localStorage.getItem("auth"));
      this.$store.commit("setState", {
        prop: "auth",
        val: auth,
      });
    }
    
    // Set up email verification watcher
    const { fb } = require('./store/util').default.fb();
    let emailVerificationCheckInterval = null;
    
    const checkEmailVerification = () => {
      const user = fb.auth().currentUser;
      if (user && !user.emailVerified && user.providerData && user.providerData.length > 0) {
        const hasPasswordProvider = user.providerData.some(p => p.providerId === 'password');
        if (hasPasswordProvider) {
          // Reload user to check if email was verified
          user.reload().then(() => {
            if (user.emailVerified && !this.$store.state.auth.emailVerified) {
              // Email was verified, update auth state
              const updatedAuth = JSON.parse(JSON.stringify(user));
              this.$store.commit("setState", {
                prop: "auth",
                val: updatedAuth,
              });
              window.localStorage.setItem("auth", JSON.stringify(updatedAuth));
              // Clear the interval once verified
              if (emailVerificationCheckInterval) {
                clearInterval(emailVerificationCheckInterval);
                emailVerificationCheckInterval = null;
              }
            }
          }).catch(err => {
            console.error('Error reloading user:', err);
          });
        }
      } else if (user && user.emailVerified) {
        // Already verified, clear interval
        if (emailVerificationCheckInterval) {
          clearInterval(emailVerificationCheckInterval);
          emailVerificationCheckInterval = null;
        }
      }
    };
    
    // Check every 5 seconds if user is logged in and email is not verified
    if (this.$store.state.auth.uid) {
      emailVerificationCheckInterval = setInterval(checkEmailVerification, 5000);
    }
    
    // Also check when auth state changes
    this.$watch('$store.state.auth.uid', (newUid, oldUid) => {
      if (newUid && !oldUid) {
        // User logged in, start checking
        if (!emailVerificationCheckInterval) {
          emailVerificationCheckInterval = setInterval(checkEmailVerification, 5000);
        }
      } else if (!newUid && oldUid) {
        // User logged out, stop checking
        if (emailVerificationCheckInterval) {
          clearInterval(emailVerificationCheckInterval);
          emailVerificationCheckInterval = null;
        }
      }
    });
  },
  name: "app",
  watch: {
    "window.innerHeight": function () {
      console.log("height change");
    },
  },
};
</script>